// IMPORTANT:
// Only import this file once, and only in `src/index.tsx` because we do not
// want to instantiate multiple query clients within our application.

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type FC, type PropsWithChildren } from "react";

// Errors that fire when a stale mutation lands after the user was
// redirected to /login (no auth token in localStorage). Logging them
// via console.error sends them to RUM as a recurring, unactionable
// noise cluster (Datadog issue 3023973c-a83f-11ef-8278-da7ad0900002).
const SUPPRESSED_MUTATION_ERROR_MESSAGES = new Set([
  "Attempt to access private route without an auth token is forbidden.",
]);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
    mutations: {
      onError(e) {
        if (
          e instanceof Error &&
          SUPPRESSED_MUTATION_ERROR_MESSAGES.has(e.message)
        ) {
          return;
        }
        console.error(e);
      },
    },
  },
});

export const QueryClientContext: FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
